import api from "./apiConfig";

const usersApi = "user-service/api/v1/user";
const advisorApi = "advisor-service/api/v1/advisors";
const topicsApi = "topic-service/api/v1/topics";
const adminApi = "admin-service/api/v1/admin";
const appointmentApi = "appointment-service/api/v1/appointments";
const paymentsApi = "payment-service/api/v1/payments";

// const adminApi = ":8001/admin-service/api/v1/admin";
// const advisorApi = ":8002/advisor-service/api/v1/advisors";
// const appointmentApi = ":8003/appointment-service/api/v1/appointments";
// const paymentsApi = ":8005/payment-service/api/v1/payments";
// const topicsApi = ":8006/topic-service/api/v1/topics";
// const usersApi = ":8007/user-service/api/v1/user";

const auth = {
  userLogin: (data) => api.post(`${usersApi}/login`, data),
  userGoogleLogin: (data) => api.post(`${usersApi}/googleLogin`, data),
  userFacebookLogin: (data) => api.post(`${usersApi}/facebookLogin`, data),
  socialLogin: (data) => api.post(`${usersApi}/social-login`, data),
  socialRegister: (data) => api.post(`${usersApi}/social-register`, data),
  register: (data) => api.post(`${usersApi}/signup`, data),
  subscribeUs: (data) => api.post(`${adminApi}/subscribeUs`, data),
  applyCouponCode: (data) => api.post(`${paymentsApi}/applyCoupon`, data),
  updatePaymentOrder: (data) => api.post(`${paymentsApi}/updatePayment`, data),
  createPaymentOrder: (data) => api.post(`${paymentsApi}/order`, data),
  paymentData: (data) => api.post(`${paymentsApi}/fetchPayment`, data),
  updateUser: (data) => api.put(`${usersApi}/updateProfile`, data),
  passwordChange: (data) => api.put(`${usersApi}/changePassword`, data),
  verifyProfile: (token) => api.get(`${usersApi}/verify-profile?token=${token}`),
  sendForgotPasswordOTP: (data) => api.post(`${usersApi}/forgot-password/send-otp`, data),
  verifyForgotPasswordOTP: (data) => api.post(`${usersApi}/forgot-password/verify-otp`, data),
};

const destination = {
  topDestination: (data) => api.get(`${topicsApi}/getRecommendation`, data),
  getTopicById: (id) => api.get(`${topicsApi}/getTopicById?id=${id}`),
  getTopicRatingById: (params) => api.get(`${topicsApi}/getTopicRatingById`, { params }),
};

const advisor = {
  getTopAdvisorsList: (params) =>
    api.get(`${adminApi}/getFeatureTravelCreator`, { params }),
  getTopicDetailsById: (data) =>
    api.post(`${advisorApi}/getTopicDetailsById`, data),
  getSecureItineraryDetails: (data) =>
    api.post(`${advisorApi}/getSecureItineraryDetails`, data),
  getAdvisorTopicByType: (data) =>
    api.post(`${adminApi}/getAdvisorTopicByType`, data),
  getAdvisorTopicBySearch: (data) =>
    api.post(`${adminApi}/getAdvisorTopicByType`, data),
  getAdvisorProfileById: (params) => api.get(`${usersApi}/getUser`, { params }),
  getAdvisorProfileTopicImageById: (data) =>
    api.post(`${topicsApi}/getAdvisorTopicImg`, data),
  getUserDetailById: (params) =>
    api.get(`${usersApi}/getUserDetailById`, { params }),
};

const verifiedAdvisors = {
  getVerifiedAdvisors: (params) => api.get(`${topicsApi}`, { params }),
};

const topExpriences = {
  getTopExperiences: (params) =>
    api.get(`${adminApi}/topExpriences`, { params }),
};

const topDestination = {
  getTopDestination: (params) =>
    api.get(`${adminApi}/topDestination`, { params }),
};

const needSupport = {
  createSupport: (data) => api.post(`${adminApi}/needSupport`, data),
};

const reachUs = {
  createReachUs: (data) => api.post(`${adminApi}/reachUs`, data),
};

const reportIssue = {
  createReportAnIssue: (data) => api.post(`${adminApi}/reportAnIssue`, data),
};

const search = {
  filterBy: (data) => api.post(`${adminApi}/search`, data),
  searchSuggestions: (data) =>
    api.get(`${adminApi}/search/suggestions?query=${data}`),
};

const recommendation = {
  getMostRecommendation: (params) =>
    api.get(`${topicsApi}/getRecommendation`, { params }),
};

const AvaliableTimeSlots = {
  getAvailableSlots: (data) =>
    api.get(`${appointmentApi}/getAdvisorTimeSlots?advisor_id=${data}`, data),
  createSlots: (data) => api.post(`${appointmentApi}/createAppointment`, data),
  updateSlots: (data) => api.put(`${appointmentApi}/updateAppointment`, data),
};

const appointment = {
  getAppointmentList: (data) =>
    api.post(`${appointmentApi}/appointmentList`, data),
  appointmentRating: (data) => api.post(`${usersApi}/appointmentRating`, data),
  cancelAppointment: (data) =>
    api.post(`${appointmentApi}/cancelAppointment`, data),
};

const findAvaliableTimeSlots = {
  CheckAvaliableTimeSlots: (data) =>
    api.post(`${adminApi}/advisorAvailableOnDate`, data),
};

const likeDislike = {
  topicLikeDislike: (data) => api.post(`${usersApi}/topic_like_dislike`, data),
};

const apiModules = {
  auth,
  destination,
  advisor,
  verifiedAdvisors,
  topExpriences,
  topDestination,
  reportIssue,
  needSupport,
  search,
  recommendation,
  AvaliableTimeSlots,
  findAvaliableTimeSlots,
  appointment,
  reachUs,
  likeDislike,
};

export default apiModules;
